export default {
  modalContent: {
    minHeight: '50vh',
    overflow: 'show'
  }
};